export enum ViewStatus {
    ACTIVE = 0,
    INACTIVE = 1,
    ARCHIVED = 2,
}
